import React from 'react';
import '../styles/ImageGameSummary.css'

export default function ImageGameSummary({ scoreboard, handleLeaveLobby, handleReturnToLobby }) {
    const filteredScoreboard = scoreboard.filter(player => !player.isSpectator);
    const sortedScoreboard = [...scoreboard].sort((a, b) => b.score - a.score);

    const getPodiumClass = (index) => {
        if (index === 0) return 'winner-gold summary-card-winner';
        if (index === 1) return 'winner-silver summary-card-winner';
        if (index === 2) return 'winner-bronze summary-card-winner';
        return '';
    };

    return (
        <div className="game-summary-container"> {/* Neuer äußerer Container für Zentrierung/Padding */}
            <div className="game-summary">
                <h2>Endergebnis</h2>
                <div className="scoreboard-list">
                    {sortedScoreboard.map((player, index) => (
                        <div
                            key={player.persistentId}
                            className={`scoreboard-entry summary-card ${getPodiumClass(index)}`}
                        >
                            <div className="player-rank">
                                {index === 0 && <i className="fas fa-crown rank-icon gold"></i>}
                                {index === 1 && <i className="fas fa-medal rank-icon silver"></i>}
                                {index === 2 && <i className="fas fa-medal rank-icon bronze"></i>}
                                <span className="position">{index + 1}.</span>
                            </div>
                            <span className="name">{player.name}</span>
                            <span className="score">
                                <i className="fas fa-star score-icon"></i>
                                {player.score} Punkte
                            </span>
                        </div>
                    ))}
                    {sortedScoreboard.length === 0 && (
                        <p className="no-players-summary">Keine Spielerdaten vorhanden.</p>
                    )}
                </div>

                <div className="summary-actions">
                    <button className="button button-secondary" onClick={handleLeaveLobby}>
                        <i className="fas fa-sign-out-alt"></i>
                        Lobby verlassen
                    </button>
                    <button className="button button-primary" onClick={handleReturnToLobby}>
                        <i className="fas fa-redo"></i>
                        Zurück zur Lobby
                    </button>
                </div>
            </div>
        </div>
    );
}
